/* eslint-disable jira/filename-case */
import type { ItemProperties } from '@jira/global-pages__dashboard-user-preference/src/types.tsx';
import { convertUserPrefsToColumnNames } from './convert-user-prefs-to-column-names.tsx';
import { getSortFieldAndDirection } from './get-sort-field-and-direction.tsx';
import { isFilterId } from './is-filter-id.tsx';

export const transformToValidUserPrefs = (
	rawUserPrefs: ItemProperties,
): {
	filterId: string | undefined;
	columnNames: string[];
	num: number;
	sortDirection: 'ASC' | 'DESC' | undefined;
	sortField: string | undefined;
	showResolved: boolean;
} => {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	const pageSize = parseInt(rawUserPrefs.num as string, 10);
	const fieldSetIds = convertUserPrefsToColumnNames(rawUserPrefs.columnNames);
	const stringifiedFilterId = `${rawUserPrefs.filterId}`;

	const { sortDirection, sortField } = getSortFieldAndDirection(rawUserPrefs.sortBy);
	const showResolved = !!rawUserPrefs.showResolved;
	return {
		filterId: isFilterId(stringifiedFilterId) ? stringifiedFilterId : undefined,
		columnNames: fieldSetIds,
		num: !Number.isNaN(pageSize) ? pageSize : 10,
		sortDirection,
		sortField,
		showResolved,
	};
};
